import {Config} from "angular-ecmascript/module-helpers";

export var Colors = {
    primary:'#F8F8F8',
    highlight1: '#187DD6',
    textNormal: '#888888',
    textHeader: '#5A5A5A',
    bg: '#DFDFDF'
};

export default class MainConfig extends Config {
    static $inject = ['$ionicConfigProvider', '$animateProvider', '$compileProvider'];


    configure() {
        this.$ionicConfigProvider.scrolling.jsScrolling(false);
        this.$ionicConfigProvider.tabs.position('bottom');
        this.$ionicConfigProvider.tabs.style('standard');

        this.$compileProvider.debugInfoEnabled(false);
        //this.$compileProvider.commentDirectivesEnabled(false);
        //this.$compileProvider.cssClassDirectivesEnabled(false);

        // By default, the $animate service will check for animation styling
        // on every structural change. This requires a lot of animateFrame-based
        // DOM-inspection. However, we can tell $animate to only check for
        // animations on elements that have a specific class name RegExp pattern
        // present. In this case, we are requiring the "animated" class.
        this.$animateProvider.classNameFilter(/\banimated\b/);
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/main.config.js